import { Typography } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles, useTheme } from "@material-ui/styles";
import CallMadeIcon from "components/common/CallMadeIcon";
import Loading from "components/common/Loading";
import RequestExecutiveForm from "components/request-document/executive/RequestTalentForm";
import RequestExecutiveInfo from "components/request-document/executive/RequestTalentInfo";
import usePersonalDetail from "components/request-document/hooks/usePersonalDetail";
import useSmartForm from "components/request-document/hooks/useSmartForm";
import RequestInvestorTalentForm from "components/request-document/investor/RequestTalentForm";
import RequestInvestorTalentInfo from "components/request-document/investor/RequestTalentInfo";
import RequestOtherTalentInfo from "components/request-document/other/RequestTalentInfo";
import RequestStartupTalentForm from "components/request-document/startup/RequestTalentForm";
import RequestStartupTalentInfo from "components/request-document/startup/RequestTalentInfo";
import RequestTalentForm from "components/request-document/talent/RequestTalentForm";
import RequestTalentInfo from "components/request-document/talent/RequestTalentInfo";
import { HOME_TAB, SMART_T_STEP } from "libs/constant/Step";
import useAuth from "libs/hooks/useAuth";
import useModalLoading from "libs/hooks/useModalLoading";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHomeTab, setSmartFormStep } from "redux/modules/uiSlice";
import {
  addSmartFormSlice,
  documentRequiredSlice,
  getDocumentRequired,
  getSmartForm,
  getSmartServiceList,
  selectCurrentSmartServiceId,
  selectDocumentRequired,
  selectSmartService,
  setSmartServiceId
} from "redux/modules/visaForm";

const useStyles = makeStyles((theme) => ({
  row: {
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    [theme.breakpoints.up("lg")]: {
      // flexWrap: "nowrap",
    },
  },
  card: {
    // minWidth: 180,
    width: 155,
    height: 170,
    // flex: 1,
    margin: "2% 1%",
    [theme.breakpoints.up("lg")]: {
      // flex: "1 1 23%;",
      margin: "1% 1%",
    },
    borderRadius: 16,
    padding: theme.spacing(2),
    paddingBottom: theme.spacing(3),
    backgroundColor: "red",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      cursor: "pointer",
    },
  },
  wrapIcon: {
    display: "flex",
    flexDirection: "row",
    marginTop: theme.spacing(2),
    flex: 1,
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  typeAlias: {
    marginLeft: -4,
    marginTop: -48,
    width: 37.6,
    textAlign: "center",
  },
  wrapCopyIcon: {
    width: 37.6,
    height: 47,
  },
  type: {
    opacity: 0.7,
  },
  paper: {
    position: "absolute",
    height: "90%",
    width: "90%",
    maxWidth: 1000,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "scroll",
  },
}));

function VisaTypeCard({
  smartserviceId,
  smartserviceName,
  smartserviceFullName,
  description,
  color,
  onClick,
}) {
  const classes = useStyles();
  const typeAlias = description.replace(/\((.*)\)/g, "$1")[0]?.toUpperCase();

  return (
    <div
      className={classes.card}
      style={{ backgroundColor: color }}
      onClick={() => onClick(smartserviceId)}
    >
      <div>
        <Typography variant="subTitle1">{smartserviceName}</Typography>
        <Typography variant="h5">{smartserviceFullName}</Typography>
        <Typography variant="body" className={classes.type}>
          {description}
        </Typography>
      </div>
      <div className={classes.wrapIcon}>
        <div className={classes.wrapCopyIcon}>
          <img alt="copy-icon" src={"./assets/copy.svg"}></img>
          <Typography variant="h4" className={classes.typeAlias}>
            {typeAlias}
          </Typography>
        </div>
        <CallMadeIcon />
      </div>
    </div>
  );
}

export default function VisaType() {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const modalLoading = useModalLoading();
  const [isRequesting, setRequesting] = useState(false);
  const [isModalSmartTVisible, setModalSmartTVisible] = useState(false);
  const [isModalSmartTFormVisible, setModalSmartTFormVisible] = useState(false);
  const { addSmartForm } = useSmartForm();
  const { personalId } = usePersonalDetail();
  const { TypeOfUser } = useAuth();

  const { isLoading: isLoadingSmartService, data } =
    useSelector(selectSmartService);
  const { isLoading, isSuccess, isFailure } = useSelector(
    selectDocumentRequired
  );

  const smartserviceId = useSelector(selectCurrentSmartServiceId);
  const smartService = useSelector(selectSmartService);
  const currentSmart = _.get(smartService, "data", []).find(
    (v) => v.smartserviceId === smartserviceId
  );
  const smartserviceName = _.get(currentSmart, "smartserviceName", "");

  useEffect(() => {
    dispatch(getSmartServiceList());
  }, [dispatch]);

  useEffect(() => {
    if (isRequesting) {
      if (isLoading) {
        modalLoading.showLoading();
      } else if (isSuccess || isFailure) {
        modalLoading.hideLoading();
      }

      if (isSuccess) {
        setRequesting(false);
        setModalSmartTVisible(true);
      }
    }
  }, [isLoading, isSuccess, isFailure, modalLoading, isRequesting]);

  const handleClickStamrtT = (smartserviceId) => {
    setRequesting(true);
    dispatch(setSmartServiceId(smartserviceId));
    dispatch(getDocumentRequired({ smartserviceId, isUpload: false }));
  };
  const handleStamrtTModalClose = () => {
    setModalSmartTVisible(false);
    dispatch(documentRequiredSlice.actions.clearAsyncState());
  };

  const colorList = [
    theme.palette.turquoiseBlue.main,
    theme.palette.secondary.main,
    theme.palette.primary.main,
    theme.palette.tropaz.main,
    theme.palette.darkIndigo.main,
  ];

  const smartServiceList = data.map((smartService, index) => ({
    ...smartService,
    color: colorList[index] || theme.palette.primary.main,
    onClick: handleClickStamrtT,
  }));

  console.log("smartServiceList ", smartServiceList);

  const handleSubmitInfo = async () => {
    if (smartserviceName === "Smart O") {
      try {
        modalLoading.showLoading();
        const prepareData = {
          draftId: null,
          smartserviceId,
          personalId,
          survey: null,
          visaissuance: null,
          detail: [],
        };
        const response = await addSmartForm({ data: prepareData })
        await dispatch(getSmartForm({ draftId: response?.payload?.draftId }))
        dispatch(documentRequiredSlice.actions.clearAsyncState());
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        modalLoading.hideLoading();
        setModalSmartTVisible(false);
        setModalSmartTFormVisible(false);
        dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
        dispatch(
          setHomeTab(HOME_TAB.CHECK_STATUS)
        );
      } catch (error) {
        modalLoading.hideLoading();
      }
    } else {
      setModalSmartTVisible(false);
      setModalSmartTFormVisible(true);
    }
  };

  const handleSmartTFormClose = () => {
    setModalSmartTFormVisible(false);
  };

  const handleSmartTFormSubmit = () => {
    dispatch(documentRequiredSlice.actions.clearAsyncState());
    setModalSmartTVisible(false);
    setModalSmartTFormVisible(false);
    dispatch(setSmartFormStep(SMART_T_STEP.UPLOAD_PASSPORT));
    dispatch(
      setHomeTab(HOME_TAB.CHECK_STATUS)
    );
  };

  let RequestForm;
  let RequestInfo;

  switch (smartserviceName) {
    case "Smart T": {
      RequestForm = RequestTalentForm;
      RequestInfo = RequestTalentInfo;
      break;
    }
    case "Smart E": {
      RequestForm = RequestExecutiveForm;
      RequestInfo = RequestExecutiveInfo;
      break;
    }
    case "Smart I": {
      RequestForm = RequestInvestorTalentForm;
      RequestInfo = RequestInvestorTalentInfo;
      break;
    }
    case "Smart O": {
      RequestForm = null;
      RequestInfo = RequestOtherTalentInfo;
      break;
    }
    case "Smart S": {
      RequestForm = RequestStartupTalentForm;
      RequestInfo = RequestStartupTalentInfo;
      break;
    }
    default: {
      break;
    }
  }

  return (
    <div className={classes.row}>
      {isLoadingSmartService ? (
        <Loading />
      ) : (
        smartServiceList.map((smartService) => (
          <VisaTypeCard key={smartService.smartserviceId} {...smartService} />
        ))
      )}

      <Dialog
        open={isModalSmartTVisible}
        onClose={handleStamrtTModalClose}
        maxWidth="lg"
      >
        <DialogContent>
          <RequestInfo
            onCancel={handleStamrtTModalClose}
            onSubmit={handleSubmitInfo}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={isModalSmartTFormVisible}
        onClose={handleSmartTFormClose}
        maxWidth="lg"
      >
        <DialogContent>
          <RequestForm
            onCancel={handleSmartTFormClose}
            onSubmit={handleSmartTFormSubmit}
          />
        </DialogContent>
      </Dialog>
    </div>
  );
}
